import { z } from 'zod';

import { WorkoutPlanId } from '../BrandedIds';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GenerateAndSendFlexModCancellationNoticeSideEffectContext = BaseLoanIdSideEffect.extend({
  workoutPlanId: WorkoutPlanId,
});
export const GenerateAndSendFlexModCancellationNoticeSideEffect =
  GenerateAndSendFlexModCancellationNoticeSideEffectContext.extend({
    type: z.literal('generateAndSendFlexModCancellationNotice'),
  });
export type GenerateAndSendFlexModCancellationNoticeSideEffect = z.infer<
  typeof GenerateAndSendFlexModCancellationNoticeSideEffect
>;
